export default "__VITE_ASSET__2c55887f__"